import { Text } from '@chakra-ui/react';

import CoverageConsentModal from './CoverageConsentModal';

interface LiabilityLimitConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (consentMethod: number) => void;
  currentLimit: string;
  newLimit: string;
  isLoading?: boolean;
}

const LiabilityLimitConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  currentLimit,
  newLimit,
  isLoading = false,
}: LiabilityLimitConfirmationModalProps) => {
  const warningContent = (
    <>
      <Text fontSize="sm" fontWeight="600" mb={2}>
        The recommended liability limit is $2,000,000.
      </Text>
      <Text fontSize="sm">
        You are reducing the liability limit from{' '}
        <Text as="span" fontWeight="600">
          {currentLimit}
        </Text>{' '}
        to{' '}
        <Text as="span" fontWeight="600">
          {newLimit}
        </Text>
        .
      </Text>
    </>
  );

  return (
    <CoverageConsentModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
      title="Liability Limit Reduction"
      warningContent={warningContent}
      attestationText="I have advised my client of the recommended $2,000,000 liability limit and its importance. Client has agreed to opt out of this coverage regardless of recommendation."
    />
  );
};

export default LiabilityLimitConfirmationModal;
